<template>
    <v-container
        class="pt-0 mt-3"
    >

                <!--------------------------------->
                <!--  Set Outer Component Rules  -->
                <!--------------------------------->
        <v-row
            justify="center"
            align="center"
            class="flex-nowrap"
        >

                <!--------------------------------->
                <!--      Scroll Left Button     -->
                <!--------------------------------->
            <v-btn
                icon
                color="grey darken-4"
                class="ml-3 mr-1"
                @click.prevent="foodTypesScrollLeft"
            >
                <v-icon
                    large
                >
                    mdi-chevron-left
                </v-icon>
            </v-btn>

                <!--------------------------------->
                <!--      Scrollable Section     -->
                <!--------------------------------->
            <v-container
                id="foodTypes"
                align="center"
                justify="center"
                class="foodTypes"
            >

                <!--------------------------------->
                <!--       Option Iterator       -->
                <!--------------------------------->
                <v-col
                    v-for="(foodType,t) in foodTypes"
                    :key="t"
                    flat
                    class="text-no-wrap"
                >
                    <v-card
                        flat
                        width="78"
                        height="95"
                        color="#ffffff"
                    >
                        <v-row
                            justify="center"
                        >
                            <v-avatar
                                v-if="foodType.selected | foodType.selected == 'true'"
                                size="84"
                                color="#74cf74"
                                @click.prevent="updateFoodTypes(t)"
                            >
                                <v-avatar
                                    size="76"
                                >
                                    <img
                                        :src="require('@/assets/taste/' + foodType.img)"
                                    />
                                </v-avatar>
                            </v-avatar>
                            <v-avatar
                                v-else
                                size="66"
                                color="grey darken-4"
                                @click.prevent="updateFoodTypes(t)"
                            >
                                <v-avatar
                                    size="62"
                                >
                                    <img
                                        :src="require('@/assets/taste/' + foodType.img)"
                                    />
                                </v-avatar>
                            </v-avatar>
                        </v-row>
                        <v-row
                            justify="center"
                            class="text-no-wrap"
                        >
                            <div
                                v-if="foodType.selected | foodType.selected == 'true'"
                                class="ma-0 pa-0 font-weight-black"
                                style="color: #74cf74;"
                            >
                                {{foodType.name}}
                            </div>
                            <div
                                v-else
                                class="ma-0 pa-0 font-weight-medium"
                            >
                                {{foodType.name}}
                            </div>
                        </v-row>
                    </v-card>
                </v-col>

            </v-container>

                <!--------------------------------->
                <!--     Scroll Right Button     -->
                <!--------------------------------->
            <v-btn
                icon
                color="grey darken-4"
                class="mr-3 ml-1"
                @click.prevent="foodTypesScrollRight"
            >
                <v-icon
                    large
                >
                    mdi-chevron-right
                </v-icon>
            </v-btn>

        </v-row>
        <v-row
            justify="center"
        >

        </v-row>

    </v-container>
</template>


<style scoped>
    .foodTypes {
        overflow-y: hidden;
        overflow-x: auto;
        display: flex;
        margin: 0px 0px 0px 0px;
        padding: 0px 5px 0px 5px;
    }

    .foodTypes::-webkit-scrollbar {
        display: none;
    }


</style>

<script>
export default {

    data: () => ({
        
    }),
    
    methods: {
        foodTypesScrollLeft: function() {
            document.getElementById('foodTypes').scrollLeft -= 204
        },
        foodTypesScrollRight: function() {
            document.getElementById('foodTypes').scrollLeft += 204
        },
        updateFoodTypes: function(value) {
            this.$store.dispatch('data/updateFoodTypes',value);
            this.$store.dispatch('data/savedPreferences')
        }
    },


    computed: {
        foodTypes() {
            return this.$store.getters['data/foodTypes'];
        },
            
    } 

};
</script>
